// The money-field currency catalog. Keys are lowercase currency codes;
// `currencies.ts` widens and wraps this table for lookups.
//
// `fractionDigits` is the minor-unit count an amount may carry (ISO 4217):
// 2 for nearly every currency, 0 for the yen and the won, which have no
// minor unit. It caps typed decimals in the editor and rounds the display.
// `config.locale` picks the group and decimal separators the display and the
// editor share; the symbol is a fixed prefix in both, ahead of the sign
// (`$-1,234.56`).
export const currencyTable = {
  usd: {
    label: "USD - US Dollar ($)",
    symbol: "$",
    fractionDigits: 2,
    config: { locale: "en-US", currency: "USD" },
  },
  eur: {
    label: "EUR - Euro (\u20ac)",
    symbol: "\u20ac",
    fractionDigits: 2,
    config: { locale: "de-DE", currency: "EUR" },
  },
  gbp: {
    label: "GBP - British Pound (\u00a3)",
    symbol: "\u00a3",
    fractionDigits: 2,
    config: { locale: "en-GB", currency: "GBP" },
  },
  jpy: {
    label: "JPY - Japanese Yen (\u00a5)",
    symbol: "\u00a5",
    fractionDigits: 0,
    config: { locale: "ja-JP", currency: "JPY" },
  },
  cad: {
    label: "CAD - Canadian Dollar (C$)",
    symbol: "C$",
    fractionDigits: 2,
    config: { locale: "en-CA", currency: "CAD" },
  },
  aud: {
    label: "AUD - Australian Dollar (A$)",
    symbol: "A$",
    fractionDigits: 2,
    config: { locale: "en-AU", currency: "AUD" },
  },
  inr: {
    label: "INR - Indian Rupee (\u20b9)",
    symbol: "\u20b9",
    fractionDigits: 2,
    config: { locale: "en-IN", currency: "INR" },
  },
  cny: {
    label: "CNY - Chinese Yuan (\u00a5)",
    symbol: "\u00a5",
    fractionDigits: 2,
    config: { locale: "zh-CN", currency: "CNY" },
  },
  chf: {
    label: "CHF - Swiss Franc (Fr)",
    symbol: "Fr",
    fractionDigits: 2,
    config: { locale: "de-CH", currency: "CHF" },
  },
  sgd: {
    label: "SGD - Singapore Dollar (S$)",
    symbol: "S$",
    fractionDigits: 2,
    config: { locale: "en-SG", currency: "SGD" },
  },
  hkd: {
    label: "HKD - Hong Kong Dollar (HK$)",
    symbol: "HK$",
    fractionDigits: 2,
    config: { locale: "zh-HK", currency: "HKD" },
  },
  nzd: {
    label: "NZD - New Zealand Dollar (NZ$)",
    symbol: "NZ$",
    fractionDigits: 2,
    config: { locale: "en-NZ", currency: "NZD" },
  },
  mxn: {
    label: "MXN - Mexican Peso (Mex$)",
    symbol: "Mex$",
    fractionDigits: 2,
    config: { locale: "es-MX", currency: "MXN" },
  },
  brl: {
    label: "BRL - Brazilian Real (R$)",
    symbol: "R$",
    fractionDigits: 2,
    config: { locale: "pt-BR", currency: "BRL" },
  },
  zar: {
    label: "ZAR - South African Rand (R)",
    symbol: "R",
    fractionDigits: 2,
    config: { locale: "en-ZA", currency: "ZAR" },
  },
  sek: {
    label: "SEK - Swedish Krona (kr)",
    symbol: "kr",
    fractionDigits: 2,
    config: { locale: "sv-SE", currency: "SEK" },
  },
  nok: {
    label: "NOK - Norwegian Krone (kr)",
    symbol: "kr",
    fractionDigits: 2,
    config: { locale: "nb-NO", currency: "NOK" },
  },
  dkk: {
    label: "DKK - Danish Krone (kr)",
    symbol: "kr",
    fractionDigits: 2,
    config: { locale: "da-DK", currency: "DKK" },
  },
  pln: {
    label: "PLN - Polish Z\u0142oty (z\u0142)",
    symbol: "z\u0142",
    fractionDigits: 2,
    config: { locale: "pl-PL", currency: "PLN" },
  },
  try: {
    label: "TRY - Turkish Lira (\u20ba)",
    symbol: "\u20ba",
    fractionDigits: 2,
    config: { locale: "tr-TR", currency: "TRY" },
  },
  aed: {
    label: "AED - UAE Dirham (\u062f.\u0625)",
    symbol: "\u062f.\u0625",
    fractionDigits: 2,
    config: { locale: "ar-AE", currency: "AED" },
  },
  ils: {
    label: "ILS - Israeli New Shekel (\u20aa)",
    symbol: "\u20aa",
    fractionDigits: 2,
    config: { locale: "he-IL", currency: "ILS" },
  },
  krw: {
    label: "KRW - South Korean Won (\u20a9)",
    symbol: "\u20a9",
    fractionDigits: 0,
    config: { locale: "ko-KR", currency: "KRW" },
  },
  thb: {
    label: "THB - Thai Baht (\u0e3f)",
    symbol: "\u0e3f",
    fractionDigits: 2,
    config: { locale: "th-TH", currency: "THB" },
  },
  myr: {
    label: "MYR - Malaysian Ringgit (RM)",
    symbol: "RM",
    fractionDigits: 2,
    config: { locale: "ms-MY", currency: "MYR" },
  },
  php: {
    label: "PHP - Philippine Peso (\u20b1)",
    symbol: "\u20b1",
    fractionDigits: 2,
    config: { locale: "en-PH", currency: "PHP" },
  },
} as const;
